import { graphql, useStaticQuery } from 'gatsby';
import { Kfh_ExtraContentSeoType } from '../types/graphqlTypes';

export const useSeoData = (): Kfh_ExtraContentSeoType[] => {
  const { allKfhExtraContentSeoType } = useStaticQuery(
    graphql`
      query GET_BASIC_SEARCH_SEO {
        allKfhExtraContentSeoType {
          nodes {
            id
            metaCopyright
            h1
            htmlDescription
            metaAuthor
            metaKeywords
            metaDescription
            noFollow
            noIndex
            onlynewhomes
            title
            category
            type
            searchType
            unavailable
            propertyEndpointApi
          }
        }
      }
    `
  );

  return allKfhExtraContentSeoType.nodes;
};
